import { Geometry } from 'models/map'
import bbox from '@turf/bbox'
import { Bounds } from 'models/map'

export const coordinatesToLngLat = ([lng, lat]: number[]) => ({ lng, lat })

export const getBoundsFromGeometry = (geometry: Geometry): Bounds => {
  const bounds = bbox(geometry)
  return [
    [bounds[0], bounds[1]],
    [bounds[2], bounds[3]],
  ]
}
